"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var validation_1 = require("@rainbow-modules/validation");
var withCustomError_1 = __importDefault(require("../helpers/withCustomError"));
var isEmptyValue_1 = __importDefault(require("../helpers/isEmptyValue"));
var isValidEmail = function (value) {
    if (isEmptyValue_1.default(value) || validation_1.isEmail(value)) {
        return undefined;
    }
    return 'The email is invalid.';
};
exports.default = withCustomError_1.default(isValidEmail);
//# sourceMappingURL=isEmail.js.map